import React from 'react';

const Contact = ({ contactList }) => {

  return (
    <footer className="contact" id="contact">
      <div className="contact-title">
        <span>Contact Me</span>
      </div>

      <div className="contact-social">
        <ul>
          <li><a href="mailto:fadlihdytullah@gmail.com" rel="noopener noreferrer"><i className="fas fa-envelope"></i> { contactList.email }</a></li>
          <li><a href={contactList.githubUrl} rel="noopener noreferrer"><i className="fab fa-github"></i> { contactList.github }</a></li>
          <li><a href={contactList.instagramUrl} rel="noopener noreferrer"><i className="fab fa-instagram"></i> { contactList.instagram }</a></li>
          <li><a href={contactList.linkedinUrl} rel="noopener noreferrer"><i className="fab fa-linkedin"></i> { contactList.linkedin }</a></li>
        </ul>
      </div>
    </footer>
  );

}

export default Contact;